import bigImage from "../../assets/why-us/careers.jpg";
import smallImage from "../../assets/why-us/Access-control-system-in-Chennai-750x440.jpg";
import { whyUsInfo } from "../../constants";
import { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { AnimationOnScroll } from "react-animation-on-scroll";
import CircleBgMain from "../CircleBg/CircleBgMain";

export default function WhyUs() {
  const [openPlus, setOpenPlus] = useState(0);
  function handleClickPlus(id) {
    if (openPlus === id) setOpenPlus(0);
    else setOpenPlus(id);
  }
  return (
    <section id="whyUs" className="py-24 md:py-36 relative">
      <CircleBgMain />
      <div className="flex flex-col md:flex-row justify-between gap-16">
        <div className="flex flex-col w-[1/2] md:max-w-[40%] gap-2">
          <AnimationOnScroll animateIn="animate__slideInDown">
            <p className=" text-primaryBlue font-bold uppercase">why us</p>
            <h1 className="text-black text-lg md:text-xl lg:text-2xl font-bold">
              We have over 15+ years in the Tech Industry
            </h1>
            <p className="text-sm text-textGray">
              We provide best solution to fit your requirement,budget and
              schedule.
            </p>
            <div className="flex flex-col gap-2 pt-8">
              {whyUsInfo.map((info) => (
                <div className="flex gap-2">
                  <div
                    className=" text-primaryBlue pt-1 cursor-pointer"
                    onClick={() => handleClickPlus(info.id)}
                  >
                    {openPlus === info.id ? <FaMinus /> : <FaPlus />}
                  </div>
                  <div className="flex flex-col gap-2">
                    <h1 className=" uppercase font-bold">{info.title}</h1>
                    <p
                      className={`${
                        openPlus === info.id ? "slide-in-down" : "hidden"
                      } text-sm text-textGray`}
                    >
                      {info.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </AnimationOnScroll>
        </div>

        {/* images */}
        <AnimationOnScroll
          animateIn="animate__slideInUp"
          className="w-full md:w-[60%]"
        >
          <div className="mt-6 md:mt-0 gap-4 md:gap-8 grid grid-cols-3">
            <div className="h-full cursor-pointer hover:scale-110 duration-500">
              <img
                src={smallImage}
                alt=""
                className=" object-cover w-full h-full rounded-md"
              />
            </div>
            <div className="h-full col-span-2 cursor-pointer hover:scale-110 duration-500">
              <img
                src={bigImage}
                alt=""
                className=" object-cover w-full h-full rounded-md"
              />
            </div>
          </div>
        </AnimationOnScroll>
      </div>
    </section>
  );
}
